module.exports = __webpack_public_path__ + "img/timestamp.1bfe439e.svg";